import Overview from "./Overview";
import RecentActivity from "./RecentActivity";
import UserSection from "./UserSection";

const MainDashboard = ({ containerMaxWidth }) => {
  return (
    <>
      <section
        style={{ width: `calc(100% - ${containerMaxWidth}px)` }}
        className="min-h-screen  flex flex-col"
      >
        <UserSection />

        <div className="bg-gray-50 h-full">
          <Overview />
          <RecentActivity />
        </div>
      </section>
    </>
  );
};

export default MainDashboard;
